import Axios from 'axios'

const setting = {
  baseURL: 'https://santarem.pa.gov.br/api/v2',
  headers: {
    'Accept': 'application/json',
    'content-type': 'application/json;charset=UTF-8'
  },
  data: {}
}

export default Axios.create(setting)
